import { envConfig } from './envConfig';

const AVA_ENV = envConfig.VITE_AVA_ENV;

const isLocal = AVA_ENV === 'local';
const isDevelop = AVA_ENV === 'develop';
const isTest = AVA_ENV === 'test';
const isStaging = AVA_ENV === 'staging';
const isUat = AVA_ENV === 'uat';
const isSandbox = AVA_ENV === 'sandbox';
const isAlpha = AVA_ENV === 'alpha';
const isProd = AVA_ENV === 'prod';

const env = { isLocal, isDevelop, isTest, isStaging, isUat, isSandbox, isAlpha, isProd };

/**
 * Gets the appropriate base API endpoint based on environment settings.
 * In local development without proxy, returns the supervisor API endpoint.
 * In all other cases, returns the provided fallback URL.
 * @param fallbackUrl - The fallback URL to use when not in local+no-proxy mode (the load balancer will redirect urls like /admin/processes to the supervisor API service)
 * @returns The API endpoint URL
 */
export function getSupervisorApiBaseUrl(fallbackUrl: string = ''): string {
  if (isLocal && import.meta.env.VITE_SETUP_PROXY_ENABLE_PROXY !== 'true') {
    return import.meta.env.VITE_SUPERVISOR_API_ENDPOINT;
  }
  return fallbackUrl;
}

export default env;
